import { Injectable } from "@angular/core";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { TourSettingsDialogComponent } from "../../components/tour-settings-dialog/tour-settings-dialog.component";

@Injectable({
    providedIn: 'root'
  })
export class TourUpdateCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      let tourId = commandInput?.parameters?.commandProviderId;

      this.dialogRef = this.dialogService.open(TourSettingsDialogComponent, {
        width: "500px",
        header: "Tour bearbeiten",
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        if(result){
          commandInput.addParameter("tourInput", result);
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
      });

    
  }
  
}